<template>
  <nav class="nav app-navbar animated" :class="{ slideInDown: show, slideOutDown: !show }">
    <div class="nav-left">
      <a class="nav-item is-brand" @click="goTo('/')">
        <img src="~assets/images/coches-small-black.png" alt="Museu Nacional dos Coches">
      </a>
    </div>

    <div class="nav-center"></div>

    <span class="nav-toggle" @click="showNavMenu = !showNavMenu">
      <span></span>
      <span></span>
      <span></span>
    </span>

    <div class="nav-right nav-menu" :class="{ 'is-active': showNavMenu }">
      <a class="nav-item" @click="goTo('/')">
        Coches
      </a>
      <a class="nav-item" @click="goTo('/users')">
        Utilizadores
      </a>

      <tooltip label="Logout" placement="bottom">
        <span class="nav-item logout-btn">
          <a class="button is-primary" href="#" @click="logout">
            <span class="icon">
              <i class="fa fa-sign-out"></i>
            </span>
            <span>{{ username }}</span>
          </a>
        </span>
      </tooltip>
    </div>
  </nav>
</template>

<script>
import { getCookie, signOut } from '../../utils/cookies'
import Tooltip from '../Util/tooltip'

export default {
  components: {
    Tooltip
  },

  props: {
    show: Boolean
  },

  data () {
    return {
      showNavMenu: false
    }
  },

  computed: {
    username () {
      return getCookie('username')
    }
  },

  methods: {
    logout () {
      signOut()
      window.router.push({
        path: '/login',
        query: { redirect: this.$store.state.route.fullPath }
      })
    },

    goTo (path) {
      window.router.push({
        path: path
      })
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~bulma/sass/utilities/variables';

.app-navbar {
  position: fixed;
  min-width: 100%;
  z-index: 1024;
  box-shadow: 0 2px 3px rgba(17, 17, 17, 0.1), 0 0 0 1px rgba(17, 17, 17, 0.1);

  @media screen and (max-width: 768px) {
    .logout-btn {
      width: 100% !important;
    }

    .logout-btn .button {
      width: 100% !important;
    }
  }

  .tooltip--bottom:before, 
  .tooltip--bottom:after {
    top: 80% !important; 
  }

  /*
  .nav-right {
    align-items: stretch;
    align-items: stretch;
    flex: 1;
    justify-content: flex-end;
    overflow: hidden;
    overflow-x: auto;
    white-space: nowrap;
  }
  */
}
</style>


// WEBPACK FOOTER //
// NavBar.vue?46c340c4